import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const UniversityCard = ({ university, onFollow, isFollowing }) => {
  const handleFollowClick = () => {
    onFollow(university?.id);
  };

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden hover:shadow-md transition-all duration-200">
      <div className="p-5">
        <div className="flex items-start justify-between gap-3 mb-4">
          <div className="flex-1 min-w-0">
            <h3 className="text-xl font-bold text-foreground mb-1 truncate">
              {university?.name || 'Unknown University'}
            </h3>
          </div>
          <button
            onClick={handleFollowClick}
            className={`flex-shrink-0 p-2 rounded-full transition-all duration-200 ${
              isFollowing 
                ? 'bg-red-500/10 text-red-500 hover:bg-red-500/20' 
                : 'bg-muted/50 text-muted-foreground hover:bg-muted hover:text-foreground'
            }`}
            aria-label={isFollowing ? 'Unfollow university' : 'Follow university'}
          >
            <Icon name={isFollowing ? 'Heart' : 'HeartOff'} size={20} className={isFollowing ? 'fill-current' : ''} />
          </button>
        </div>

        <div className="grid grid-cols-3 gap-3">
          <div className="bg-gradient-to-br from-primary/5 to-primary/10 rounded-lg p-3 border border-primary/20">
            <div className="text-xs font-medium text-muted-foreground mb-1">Admit Rate</div>
            <div className="text-lg font-bold text-primary">
              {university?.admit_rate ? `${university.admit_rate}%` : 'Not specified'}
            </div>
          </div>
          <div className="bg-muted/30 rounded-lg p-3 border border-border/50">
            <div className="text-xs font-medium text-muted-foreground mb-1">Avg GPA</div>
            <div className="text-lg font-bold text-foreground">
              {university?.gpa || 'Not specified'}
            </div>
          </div>
          <div className="bg-muted/30 rounded-lg p-3 border border-border/50">
            <div className="text-xs font-medium text-muted-foreground mb-1">SAT Range</div>
            <div className="text-sm font-bold text-foreground">
              {university?.sat || 'Not specified'}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UniversityCard;
